import React from 'react';
import TextInput from './TextInput';
import {useTranslation} from 'react-i18next';

function LoginCredentials({account, onChange, validation, readOnly = false, passwordReset = false, showPassword = true}) {
    const [t] = useTranslation();
    return (
        <>
            {
                !passwordReset &&
                <TextInput
                    id="email"
                    type="email"
                    label={t('User.EMAIL')}
                    value={account.email}
                    onChange={value => onChange('email', value)}
                    required={true}
                    isValid={validation.email}
                    errorMessage={!validation.email && !!account.email ? t('Validation.INVALID_EMAIL') : null}
                    readonly={readOnly}
                />
            }
            {
                showPassword &&
                <div className="row">
                    <div className="col-12 col-lg-6">
                        <TextInput
                            id="password"
                            type="password"
                            label={t('Account.PASSWORD_CHANGE')}
                            value={account.password}
                            onChange={value => onChange('password', value)}
                            required={true}
                            isValid={validation.password}
                            readonly={readOnly}
                        />
                    </div>
                    <div className="col-12 col-lg-6">
                        <TextInput
                            id="passwordRepeat"
                            type="password"
                            label={t('Account.PASSWORD_REPEAT')}
                            value={account.passwordRepeat}
                            onChange={value => onChange('passwordRepeat', value)}
                            required={true}
                            errorMessage={account.password !== account.passwordRepeat ? t('Account.PASSWORD_NOT_MATCH') : null}
                            isValid={validation.passwordRepeat}
                            readonly={readOnly}
                        />
                    </div>
                </div>
            }
        </>
    );
}

export default LoginCredentials;
